import { useObservableState } from 'observable-hooks';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import * as yup from 'yup';

import Form, { SubmitType } from '../../../components/form';
import Button from '../../../components/form/elements/button';
import Group from '../../../components/form/elements/group';
import Link from '../../../components/form/elements/link';
import Readonly from '../../../components/form/elements/readonly';
import Text from '../../../components/form/elements/text';
import TextArea from '../../../components/form/elements/text-area';
import EmailTemplate from '../../../interfaces/email-template';
import { INTERNAL_EMAIL_TEMPLATE_INDEX } from '../../../router/routes';
import { useService } from '../../../services/services';
import { route } from '../../../services/utils';

const createEmailTemplateSchema = yup.object().shape({
  name: yup.string().max(255).required(),
  subject: yup.string().max(255).required(),
  body: yup.string(),
});

export default function EditEmailTemplate() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const { emailTemplateService } = useService();
  const [bodyElements, setBodyElements] = useState([]);
  const [footerElements, setFooterElements] = useState([]);

  const [emailTemplate] = useObservableState<EmailTemplate>(
    () => emailTemplateService.show(id),
    null
  );

  useEffect(() => {
    if (emailTemplate !== null) {
      setBodyElements([
        Group([
          Readonly([Text('name', 'tempalte')]),
          Text('subject'),
          TextArea('body', 'body', 15),
        ]),
      ]);

      setFooterElements([
        Button('save'),
        Link(route(INTERNAL_EMAIL_TEMPLATE_INDEX), 'cancel'),
      ]);
    }
  }, [id, emailTemplate, setBodyElements]);

  const submit = useCallback<SubmitType<EmailTemplate>>(
    (form) => [
      emailTemplateService.update(id, form),
      (response) => {
        history.push(route(INTERNAL_EMAIL_TEMPLATE_INDEX));
      },
    ],
    [id, emailTemplateService, history]
  );

  return (
    <Form
      title={
        emailTemplate
          ? emailTemplate.name
          : t('pages.internal.email-templates.Edit email template')
      }
      mode={'edit'}
      body={bodyElements}
      footer={footerElements}
      values={emailTemplate}
      submit={submit}
      schema={createEmailTemplateSchema}
    />
  );
}
